import { ReactNode } from 'react'
import { useLocationAlerts } from '../../../hooks/alerts'
import { Card, Stack } from '@mui/material'
import SmsFailedRoundedIcon from '@mui/icons-material/SmsFailedRounded'
import Badge from '@mui/material/Badge'
import { Box, Typography } from '@mui/material'

export const Notice = ({ icon, children }: { icon: string; children: ReactNode }) => {
  return (
    <Stack direction="row" spacing={1.5} alignItems="flex-start" sx={{ px: 2, py: 0.5 }}>
      <Box component="img" src={icon} alt="" sx={{ width: 20, height: 20, mt: '2px', flexShrink: 0 }} />
      <Box sx={{ whiteSpace: 'pre-wrap' }}>{children}</Box>
    </Stack>
  )
}

const getAlertImage = () => {
  return require('../../../images/alert_icon.png')
}

const AlertsCard = ({ propertyId, ...props }) => {
  const { data: alerts } = useLocationAlerts(propertyId, {
    only_active: true,
  })

  const showAlerts = () => {
    if (alerts && alerts.length) {
      return alerts.map((alerts, index) => <Notice key={index} children={alerts.message} icon={getAlertImage()} />)
    }
  }

  const showWeatherWarnings = () => {
    if (props.activeweatherwarnings && props.activeweatherwarnings.length) {
      return props.activeweatherwarnings.map((warning, index) => (
        <Notice key={index} children={warning.summary} icon={getAlertImage()} />
      ))
    }
  }

  const numberOfAlerts: number = [
    alerts?.length ?? 0,
    props.gaugereadings?.length ?? 0,
    props.activeweatherwarnings?.length ?? 0,
  ].reduce((sum, length) => sum + length, 0)

  return (
    <>
      <Card>
        <Badge
          badgeContent={numberOfAlerts}
          color="primary"
          sx={{
            '& .MuiBadge-badge': {
              right: -15,
              top: 12,
              padding: '0 4px',
            },
          }}>
          <Typography>Active Alerts</Typography>
        </Badge>
        <Box my={1}>
          {numberOfAlerts > 0 ? (
            <Box>
              {showAlerts()}
              {showWeatherWarnings()}
            </Box>
          ) : (
            <Stack direction="row" spacing={2} pl={2} pt={2}>
              <SmsFailedRoundedIcon />
              <Typography>No alerts</Typography>
            </Stack>
          )}
        </Box>
      </Card>
    </>
  )
}

export default AlertsCard
